import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "time-out-accept" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "accept-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "¡Fantastico!", -1)
const _hoisted_5 = { id: "accept-content-text" }
const _hoisted_6 = { style: {"text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListElement = _resolveComponent("ListElement")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      id: "time-out-exit-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('exitSteps')))
    }, [
      _createElementVNode("img", {
        src: require('@/assets/images/salir.png'),
        alt: "step1"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, " A partir del día " + _toDisplayString(_ctx.currentSubscription.nextPayDate) + " podrás seguir con estas funcionalidades: ", 1),
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elementsFeatured, (element) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "elements-step3",
            key: element
          }, [
            _createVNode(_component_ListElement, {
              element: element,
              type: "finally"
            }, null, 8, ["element"])
          ]))
        }), 128))
      ]),
      _createVNode(_component_Button, {
        variant: "turquoise",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateProfile')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("¡Perfecto!")
        ]),
        _: 1
      })
    ])
  ]))
}